/*
 * @Description:数据接口
 * @Author: 山淑兰
 * @Date: 2019-11-20 10:39:29
 * @LastEditTime: 2020-05-14 17:21:51
 * @LastEditors: 山淑兰
 */
const API_HOST = ''
//const API_HOST = 'http://test.mt.weiqihd.com'
const API_PATH = {
	MEETING_INFO: API_HOST + '/api/Meeting/InitMeetingInfo', // 会议基本信息接口
	LIVE_DATA: API_HOST + '/api/MeetingSign/GetUserLiveData', // 获取用户观看数据
	SCHEDULE_INFO: API_HOST + '/api/Program/GetAPIProgram', //日程信息
	GUEST_INFO: API_HOST + '/api/Program/GetAPIExpertProgram', //嘉宾日程信息
	CSDATA: API_HOST + '/api/Wx/WxBKMConfig', //微信jssdk
	VER_SENDMSG: API_HOST + '/api/Ver/SendMsg', //发送验证码
	VER_SENDVIOCEMSG: API_HOST + '/api/Ver/SendVioceMsg', //发送语音验证码
	VER_WXLOGIN: API_HOST + '/api/Ver/VerWxLogin', //获取token
	Ver_MobileReg: API_HOST + '/api/Ver/MobileReg', //登录
	Check_MeetingUserSign: API_HOST + '/api/MeetingSign/CheckMeetingUserSign', //验证是否报名
	Init_SignConfig: API_HOST + '/api/MeetingSign/InitSignConfig', //报名页配置接口
	Submit_signUp: API_HOST + '/api/MeetingSign/PostSignMeetingUser', //提交报名
	Init_SignUpSetUserConfig: API_HOST + '/api/MeetingSign/InitSignUpSetUserConfig', //报名成功数据接口
	QuerySignRemaining: API_HOST + '/api/MeetingSign/QuerySignRemaining', //查询余票
	Init_PayConfig: API_HOST + '/api/MeetingSign/InitPayConfig', //初始化支付页
	Create_PayOrder: API_HOST + '/api/MeetingSign/CreatePayOrder', //提交支付订单
	PayOrder_CallBack: API_HOST + '/api/MeetingSign/PayOrderCallBack', //易支付回调接口
	Get_SignMeetingUserByMu: API_HOST + '/api/MeetingSign/GetSignMeetingUserByMu', //获取当前登录账户报名信息接口
	UploadPic: API_HOST + '/api/File/UploadPic', //上传图片
	InitSignUp_Invoice: API_HOST + '/api/MeetingSign/InitSignUpInvoice', // 获取开票信息接口
	Edit_UserInvoice: API_HOST + '/api/MeetingSign/EditUserInvoice', //编辑发票信息
	AccessTemp: API_HOST + '/api/Ver/AccessTemp', //获取非微信客户端临时Token
	Get_SignMeetingUser: API_HOST + '/api/MeetingSign/GetSignMeetingUser', //获取当前报名用户信息接口
	Edit_SignMeetingUser: API_HOST + '/api/MeetingSign/EditSignMeetingUser', //提交修改报名信息接口
	Edit_UserVouch: API_HOST + '/api/MeetingSign/EditUserVouch', //修改支付凭证接口
	Init_CheckUser: API_HOST + '/api/MeetingSign/InitCheckUser', //签到二维码页面(登录后)
	InitOpenCheckUser: API_HOST + '/api/MeetingSign/InitOpenCheckUser', //签到二维码页面(无需登录)
	Init_AddSignConfig: API_HOST + '/api/MeetingSign/InitAddSignConfig', //添加人员，初始化配置数据接口
	Post_AddPageSignMeetingUser: API_HOST + '/api/MeetingSign/PostAddPageSignMeetingUser', //添加人员页面提交数据接口
	QueryOrder: API_HOST + '/api/Wx/QueryOrder', //查询订单是否支付状态
	Navigation: API_HOST + '/api/MeetingSign/InitMeetingNavigation', //底部导航栏接口
	userCentert: API_HOST + '/api/UserCenter/InitUserCentert', //个人中心获取个人信息接口
	checkModfiyUser: API_HOST + '/api/UserCenter/CheckModfiyUser', //验证绑定的手机号是否正确，并验证验证码
	modfiyPhone: API_HOST + '/api/UserCenter/ModfiyUserPhone', //修改手机号接口
	joinMeeting: API_HOST + '/api/UserCenter/InitUserJoinMeetingLog', //获取用户参会记录接口
	liveMeeting: API_HOST + '/api/Live/InitWeiQiMeetingLive', //直播间页面接口
	previewmeeting: API_HOST + '/api/Program/GetAPIPreviewProgram', //会议日程一览接口
	photoList: API_HOST + '/api/Photo/GetPhotoClass', //获取照片分类列表首页
	photoInfo: API_HOST + '/api/Photo/GetPhotoInfo', //照片直播详情页面，首次进入调用
	photoPageInfo: API_HOST + '/api/Photo/GetPhotoPageInfo', //分页加载照片列表
	hotelHomePage: API_HOST + '/api/Hotel/HotelBookHomePage', //获取酒店列表
	hotelInsidePage: API_HOST + '/api/Hotel/HotelBookInsidePage', //获取酒店配置信息
	hotelBook: API_HOST + '/api/Hotel/HotelBook', //预订
	hotelOrder: API_HOST + '/api/HotelOrder/HotelOrderList', //订单列表接口
	hotelOrderDetail: API_HOST + '/api/HotelOrder/HotelOrderDetail', //订单详情接口
	hotelOrderCancel: API_HOST + '/api/HotelOrder/HotelOrderCancel', //取消订单
	hotelOrdeRebook: API_HOST + '/api/HotelOrder/HotelOrdeRebook', //再次预订
	HotelBookMoney: API_HOST + '/api/Hotel/HotelBookMoney', //订单金额
	hotelAddInvoice: API_HOST + '/api/Hotel/HotelAddInvoice', //发票
	hotelInfoConfig: API_HOST + '/api/Hotel/HotelBookUserInfoConfig', //获取人员报名及支付信息
	hotelSignInitPayConfig: API_HOST + '/api/HotelSign/InitPayConfig', //酒店预订支付初始化
	hotelSignCreatePayOrder: API_HOST + '/api/HotelSign/CreatePayOrder', //酒店预订提交支付 
	hotelSignQueryOrder: API_HOST + '/api/HotelSign/QueryOrder', //订单状态查询
	scanCheckin: API_HOST + '/api/MeetingSign/UserScanCheckin', //扫码签到
	getProDateRoom: API_HOST + '/api/Program/GetAPIProDateRoom', //获取日期会场
	getExpertProList: API_HOST + '/api/Program/GetAPIExpertProList', //嘉宾列表
	checkExpert: API_HOST + '/api/MeetingExpert/CheckExpert', //验证嘉宾是否登录
	expertCode: API_HOST + '/api/MeetingExpert/SengExpertCode', //发送嘉宾短信验证码
	expertLogin: API_HOST + '/api/MeetingExpert/ExpertLogin', //嘉宾手机号登录
	initExpertPage: API_HOST + '/api/MeetingExpert/InitExpertPage', //嘉宾主页加载
	expertNav: API_HOST + '/api/MeetingSign/InitMeetingVIPNavigation', //嘉宾个人中心接口
	programNavigation: API_HOST + '/api/MeetingSign/InitMeetingProgramNavigation', //日程页面接口
}
export default {
	//获取日期会场
	getProDateRoom(params) {
		return this.get({
			url: API_PATH.getProDateRoom,
			params,
		})
	},
	//嘉宾列表
	getExpertProList(params) {
		return this.get({
			url: API_PATH.getExpertProList,
			params,
		})
	},
	//扫码签到
	scanCheckin(params) {
		return this.get({
			url: API_PATH.scanCheckin,
			params,
		})
	},
	//酒店预订支付初始化
	hotelSignInitPayConfig(params) {
		return this.post({
			url: API_PATH.hotelSignInitPayConfig,
			params,
		})
	},
	//酒店预订提交支付
	hotelSignCreatePayOrder(params) {
		return this.post({
			url: API_PATH.hotelSignCreatePayOrder,
			params,
		})
	},
	//订单状态查询
	hotelSignQueryOrder(params) {
		return this.post({
			url: API_PATH.hotelSignQueryOrder,
			params,
		})
	},
	//获取人员报名及支付信息
	hotelInfoConfig(params) {
		return this.get({
			url: API_PATH.hotelInfoConfig,
			params,
		})
	},
	//发票
	hotelAddInvoice(params) {
		return this.post({
			url: API_PATH.hotelAddInvoice,
			params,
		})
	},
	// 订单金额接口
	HotelBookMoney(params) {
		return this.get({
			url: API_PATH.HotelBookMoney,
			params,
		})
	},
	// 再次预订接口
	hotelOrdeRebook(params) {
		return this.get({
			url: API_PATH.hotelOrdeRebook,
			params,
		})
	},
	// 取消订单接口
	hotelOrderCancel(params) {
		return this.get({
			url: API_PATH.hotelOrderCancel,
			params,
		})
	},
	// 订单详情接口
	hotelOrderDetail(params) {
		return this.get({
			url: API_PATH.hotelOrderDetail,
			params,
		})
	},
	// 订单列表接口
	hotelOrder(params) {
		return this.get({
			url: API_PATH.hotelOrder,
			params,
		})
	},
	// 获取酒店列表
	hotelHomePage(params) {
		return this.get({
			url: API_PATH.hotelHomePage,
			params,
		})
	},
	// 获取酒店配置信息
	hotelInsidePage(params) {
		return this.get({
			url: API_PATH.hotelInsidePage,
			params,
		})
	},
	// 预订
	hotelBook(params) {
		return this.post({
			url: API_PATH.hotelBook,
			params,
		})
	},
	// 分页加载照片列表
	photoPageInfo(params) {
		return this.get({
			url: API_PATH.photoPageInfo,
			params,
		})
	},
	// 照片直播详情页面，首次进入调用
	photoInfo(params) {
		return this.get({
			url: API_PATH.photoInfo,
			params,
		})
	},
	// 获取照片分类列表首页
	photoList(params) {
		return this.get({
			url: API_PATH.photoList,
			params,
		})
	},
	// 会议日程一览接口
	previewmeeting(params) {
		return this.get({
			url: API_PATH.previewmeeting,
			params,
		})
	},
	// 直播间页面接口
	liveMeeting(params) {
		return this.get({
			url: API_PATH.liveMeeting,
			params,
		})
	},
	// 获取用户参会记录接口
	joinMeeting(params) {
		return this.get({
			url: API_PATH.joinMeeting,
			params,
		})
	},
	// 验证绑定的手机号是否正确，并验证验证码
	checkModfiyUser(params) {
		return this.post({
			url: API_PATH.checkModfiyUser,
			params,
		})
	},
	// 修改手机号接口
	modfiyPhone(params) {
		return this.post({
			url: API_PATH.modfiyPhone,
			params,
		})
	},
	// 个人中心获取个人信息接口
	userCentert(params) {
		return this.get({
			url: API_PATH.userCentert,
			params,
		})
	},
	// 底部导航栏
	Navigation(params) {
		return this.get({
			url: API_PATH.Navigation,
			params,
		})
	},
	/**
	 * @Description: 查询订单是否支付状态
	 */
	QueryOrder(params) {
		return this.get({
			url: API_PATH.QueryOrder,
			params,
		})
	},
	/**
	 * @Description: 添加人员页面提交数据接口
	 */
	AddPageSignMeetingUser(params) {
		return this.post({
			url: API_PATH.Post_AddPageSignMeetingUser,
			params,
		})
	},
	/**
	 * @Description: 修改支付凭证接口
	 */
	InitCheckUser(params) {
		return this.get({
			url: API_PATH.Init_CheckUser,
			params,
		})
	},
	/**
	 * @title: 会议详情
	 * @date: 2019-09-07
	 */
	initMeetingInfo(params) {
		return this.get({
			url: API_PATH.MEETING_INFO,
			params
		})
	},
	initScheduleInfo(params) {
		return this.get({
			url: API_PATH.SCHEDULE_INFO,
			params
		})
	},
	initGuestInfo(params) {
		return this.get({
			url: API_PATH.GUEST_INFO,
			params
		})
	},
	liveData(params) {
		return this.get({
			url: API_PATH.LIVE_DATA,
			params
		})
	},

	/**
	 * @title: 微信
	 * @date: 2019-10-11
	 */
	csData(params) {
		return this.get({
			url: API_PATH.CSDATA,
			params
		})
	},
	/**
	 * @Description: 获取token
	 */
	verWxLogin(params) {
		return this.get({
			url: API_PATH.VER_WXLOGIN,
			params
		})
	},
	/**
	 * @Description: 发送验证码
	 * @param: {object} params 参数
	 * @param: {string} token Authorization
	 */
	verSendMsg(params) {
		return this.post({
			url: API_PATH.VER_SENDMSG,
			params,
		})
	},
	verSendVioceMsg(params) {
		return this.post({
			url: API_PATH.VER_SENDVIOCEMSG,
			params,
		})
	},
	/**
	 * @Description: 登录
	 */
	VerMobileReg(params) {
		return this.post({
			url: API_PATH.Ver_MobileReg,
			params,
		})
	},
	/**
	 * @Description: 验证报名
	 */
	CheckMeetingUserSign(params) {
		return this.get({
			url: API_PATH.Check_MeetingUserSign,
			params,
		})
	},
	/**
	 * @Description: 报名配置
	 */
	InitSignConfig(params) {
		return this.get({
			url: API_PATH.Init_SignConfig,
			params,
		})
	},
	/**
	 * @Description: 查询余票
	 */
	QuerySignRemaining(params) {
		return this.get({
			url: API_PATH.QuerySignRemaining,
			params,
		})
	},
	/**
	 * @Description: 提交报名表单
	 */
	SubmitSignUp(params) {
		return this.post({
			url: API_PATH.Submit_signUp,
			params,
		})
	},
	/**
	 * @Description: 报名成功表单
	 */
	InitSignUpSetUserConfig(params) {
		return this.get({
			url: API_PATH.Init_SignUpSetUserConfig,
			params,
		})
	},
	/**
	 * @Description: 支付初始化配置
	 */
	InitPayConfig(params) {
		return this.post({
			url: API_PATH.Init_PayConfig,
			params,
		})
	},
	/**
	 * @Description: 提交支付订单
	 */
	CreatePayOrder(params) {
		return this.post({
			url: API_PATH.Create_PayOrder,
			params,
		})
	},
	/**
	 * @Description: 易支付回调接口
	 */
	PayOrderCallBack(params) {
		return this.post({
			url: API_PATH.PayOrder_CallBack,
			params,
		})
	},
	/**
	 * @Description: 获取当前登录账户报名信息接口
	 */
	GetSignMeetingUserByMu(params) {
		return this.get({
			url: API_PATH.Get_SignMeetingUserByMu,
			params,
		})
	},
	/**
	 * @Description: 上传图片
	 */
	UploadPic(params) {
		console.log(params.get('file'))
		return this.post({
			url: API_PATH.UploadPic,
			params,
			headers: {
				'Content-Type': 'multipart/form-data'
			},
		})
	},
	/**
	 * @Description: 获取开票信息接口
	 */
	InitSignUpInvoice(params) {
		return this.get({
			url: API_PATH.InitSignUp_Invoice,
			params,
		})
	},
	/**
	 * @Description: 编辑发票信息
	 */
	EditUserInvoice(params) {
		return this.post({
			url: API_PATH.Edit_UserInvoice,
			params,
		})
	},
	/**
	 * @Description: 获取非微信客户端临时Token
	 */
	AccessTemp() {
		return this.post({
			url: API_PATH.AccessTemp
		})
	},
	/**
	 * @Description: 提交修改报名信息
	 */
	EditSignMeetingUser(params) {
		return this.post({
			url: API_PATH.Edit_SignMeetingUser,
			params,
		})
	},
	/**
	 * @Description: 获取当前报名用户信息接口
	 */
	GetSignMeetingUser(params) {
		return this.post({
			url: API_PATH.Get_SignMeetingUser,
			params,
		})
	},
	/**
	 * @Description: 修改支付凭证接口
	 */
	EditUserVouch(params) {
		return this.post({
			url: API_PATH.Edit_UserVouch,
			params,
		})
	},
	/**
	 * @Description: 添加人员，初始化配置数据接口
	 */
	InitAddSignConfig(params) {
		return this.get({
			url: API_PATH.Init_AddSignConfig,
			params,
		})
	},
	/**
	 * @Description: 添加人员页面提交数据接口
	 */
	InitOpenCheckUser(params) {
		return this.get({
			url: API_PATH.InitOpenCheckUser,
			params,
		})
	},
	//验证嘉宾是否登录
	checkExpert(params) {
		return this.get({
			url: API_PATH.checkExpert,
			params,
		})
	},
	//发送嘉宾短信验证码
	expertCode(params) {
		return this.post({
			url: API_PATH.expertCode,
			params,
		})
	},
	//嘉宾手机号登录
	expertLogin(params) {
		return this.post({
			url: API_PATH.expertLogin,
			params,
		})
	},
	//嘉宾主页加载
	initExpertPage(params) {
		return this.get({
			url: API_PATH.initExpertPage,
			params,
		})
	},
	
	//嘉宾个人中心接口
	expertNav(params) {
		return this.get({
			url: API_PATH.expertNav,
			params,
		})
	},
	//日程页面接口
	programNavigation(params) {
		return this.get({
			url: API_PATH.programNavigation,
			params,
		})
	},
}